module.exports = __webpack_public_path__ + "static/M4-62ba171612b9830aca3086cda4b391b9.jpg";